import React, { useState } from "react";
import { Radio, Input, Typography } from 'antd';
import "./AssessmentQuestion.scss";

const radioStyle = {
    display: 'block',
    lineHeight: '35px',
    whiteSpace: "normal"
};
const { Title } = Typography;
const { TextArea } = Input;

const AssessmentQuestions = (props) => {
    const [state, setState] = useState({ value: props.question.answer, answers: props.question.choices });
    const onChange = e => {
        setState({
            ...state,
            value: e.target.value,
        });
        let qtn = props.question;
        qtn.answer = e.target.value
        props.updateQuestion(qtn, props.index)
    };
    const onKeyDown = e => {
        setState({
            ...state,
            value: e.target.value,
        });
        let qtn = props.question;
        qtn.answer = e.target.value
        props.updateQuestionAlone(qtn, props.index, true)
    };

    const { value, answers } = state
    return (
        <div class="assessment-qtnt">
            <Title level={4} style={{ marginBottom: 20 }}>{props.index+1}. {props.question.desc}</Title>
            <div style={{ paddingBottom: 20 }}>
            {
                answers && answers.length ? (
                    <Radio.Group onChange={onChange} value={value}>
                        {
                            answers && answers.map((answer, index) => (
                                <Radio style={radioStyle} value={answer.id} key={index}>
                                    {answer.desc}
                                </Radio>
                            ))
                        }
                    </Radio.Group>
                ) : <TextArea onChange={onKeyDown} value={value} rows={5} style={{width: "100%"}}/>
            }
                
            </div>

        </div>
    )
}
export default AssessmentQuestions